import React from "react";
import { useGetSelfQuery, useLogoutMutation } from "../../api/etApi";
import strings from "../localize/localizeSlice";
import { useAppDispatch } from "../../app/hooks";
import { updateUserInfoDataFromApi } from "../priceCalculatorForm/PriceCalculatorFormSlice";

interface LoginInfoProps {
  onLogout: () => void;
}

const LoginInfo: React.FC<LoginInfoProps> = ({ onLogout }) => {
  const { data, error, refetch } = useGetSelfQuery(undefined, { refetchOnMountOrArgChange: true });
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (data) {
      dispatch(updateUserInfoDataFromApi(data));
    }
  }, [data, dispatch, data?.Address, data?.City, data?.Country, data?.Email, data?.Name, data?.Zip, data?.Telephone]);
  const [logout] = useLogoutMutation();

  const handleLogout = async () => {
    try{
      await logout({refreshToken: "", body: "sfsdf"});
      refetch();
      onLogout();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div>
      {data && !error && (
        <div className="flex items-center gap-1">
          <h2 className="text-sm sm:text-md m-0 dark:text-white">
            {strings.formatString(strings.loginGreeding, {UserName: data.Name ?? ""})}
          </h2>
          <button
            onClick={handleLogout}
            className="text-sm sm:text-md px-2 py-2 text-cuno-500 rounded-md hover:bg-cuno-500 hover:text-white whitespace-nowrap flex-shrink-0"
          >
            {strings.logout}
          </button>
        </div>
      ) }
    </div>
  );
};

export default LoginInfo;